import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = {
  key: 0,
  class: "dev-mode__title"
}
const _hoisted_3 = {
  key: 0,
  class: "dev-mode__data"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconChevronLeft = _resolveComponent("IconChevronLeft")
  const _component_EmptyCallView = _resolveComponent("EmptyCallView")
  const _component_VideoVue = _resolveComponent("VideoVue")
  const _component_VideoBottomBar = _resolveComponent("VideoBottomBar")
  const _component_LocalVideo = _resolveComponent("LocalVideo")
  const _component_IconChevronRight = _resolveComponent("IconChevronRight")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")

  return (_openBlock(), _createElementBlock("div", {
    ref: "gridWrapper",
    class: _normalizeClass(["grid-main-wrapper", { 'is-grid': !$props.isStripe, overlap: $props.isOverlap }])
  }, [
    ($props.isStripe && !$props.isRecording)
      ? (_openBlock(), _createBlock(_component_NcButton, {
          key: 0,
          class: "stripe--collapse",
          variant: "tertiary-no-background",
          title: $options.stripeButtonTitle,
          "aria-label": $options.stripeButtonTitle,
          onClick: $options.handleClickStripeCollapse
        }, {
          icon: _withCtx(() => [
            ($options.stripeOpen)
              ? (_openBlock(), _createBlock(_component_IconChevronDown, {
                  key: 0,
                  "fill-color": "#ffffff",
                  size: 20
                }))
              : (_openBlock(), _createBlock(_component_IconChevronUp, {
                  key: 1,
                  "fill-color": "#ffffff",
                  size: 20
                }))
          ]),
          _: 1
        }, 8, ["title", "aria-label", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TransitionWrapper, {
      name: $props.isStripe ? 'slide-down' : undefined
    }, {
      default: _withCtx(() => [
        (!$props.isStripe || $options.stripeOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "wrapper",
              style: _normalizeStyle($options.wrapperStyle)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([$props.isStripe ? 'stripe-wrapper' : 'grid-wrapper'])
              }, [
                ($options.hasPreviousPage && $data.gridWidth > 0)
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 0,
                      variant: "tertiary-no-background",
                      class: "grid-navigation grid-navigation__previous",
                      "aria-label": $options.t('spreed', 'Previous page of videos'),
                      onClick: $options.handleClickPrevious
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconChevronLeft, {
                          class: "bidirectional-icon",
                          "fill-color": "#ffffff",
                          size: 20
                        })
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref: "grid",
                  class: _normalizeClass(["grid", { stripe: $props.isStripe }]),
                  style: _normalizeStyle($options.gridStyle),
                  onMousemove: _cache[0] || (_cache[0] = (...args) => ($options.handleMovement && $options.handleMovement(...args))),
                  onWheel: _cache[1] || (_cache[1] = (...args) => ($data.debounceHandleWheelEvent && $data.debounceHandleWheelEvent(...args))),
                  onKeydown: _cache[2] || (_cache[2] = (...args) => ($options.handleMovement && $options.handleMovement(...args)))
                }, [
                  (!$setup.devMode && !($options.isLessThanTwoVideos && $props.isStripe))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        ($options.videos.length === 0 && !$props.isStripe)
                          ? (_openBlock(), _createBlock(_component_EmptyCallView, {
                              key: 0,
                              class: "video",
                              "is-grid": true
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayedVideos, (callParticipantModel) => {
                          return (_openBlock(), _createBlock(_component_VideoVue, {
                            key: callParticipantModel.attributes.peerId,
                            class: _normalizeClass({ video: !$props.isStripe }),
                            "show-video-overlay": $data.showVideoOverlay,
                            token: $props.token,
                            model: callParticipantModel,
                            "is-grid": true,
                            "show-talking-highlight": !$props.isStripe,
                            "is-stripe": $props.isStripe,
                            "is-promoted": $props.sharedDatas[callParticipantModel.attributes.peerId].promoted,
                            "is-selected": $options.isSelected(callParticipantModel),
                            "shared-data": $props.sharedDatas[callParticipantModel.attributes.peerId],
                            onClickVideo: $event => ($options.handleClickVideo($event, callParticipantModel.attributes.peerId))
                          }, null, 8, ["class", "show-video-overlay", "token", "model", "show-talking-highlight", "is-stripe", "is-promoted", "is-selected", "shared-data", "onClickVideo"]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  ($setup.devMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.displayedVideos, (key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: key,
                            class: _normalizeClass(["dev-mode-video video", { 'dev-mode-screenshot': $setup.screenshotMode }])
                          }, [
                            _createElementVNode("img", {
                              alt: $options.placeholderName(key),
                              src: $options.placeholderImage(key)
                            }, null, 8, _hoisted_1),
                            _createVNode(_component_VideoBottomBar, {
                              "has-shadow": false,
                              model: $options.placeholderModel(key),
                              "shared-data": $options.placeholderSharedData(key),
                              token: $props.token,
                              "participant-name": $options.placeholderName(key, !$setup.screenshotMode)
                            }, null, 8, ["model", "shared-data", "token", "participant-name"])
                          ], 2))
                        }), 128)),
                        (!$setup.screenshotMode)
                          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, " Dev mode on ;-) "))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!$props.isStripe && !$props.isRecording)
                    ? (_openBlock(), _createBlock(_component_LocalVideo, {
                        key: 2,
                        ref: "localVideo",
                        class: "video",
                        "is-grid": "",
                        "fit-video": false,
                        token: $props.token,
                        "local-media-model": $props.localMediaModel,
                        "local-call-participant-model": $props.localCallParticipantModel,
                        onClickVideo: $options.handleClickLocalVideo
                      }, null, 8, ["token", "local-media-model", "local-call-participant-model", "onClickVideo"]))
                    : _createCommentVNode("", true)
                ], 38),
                ($options.hasNextPage && $data.gridWidth > 0)
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 1,
                      variant: "tertiary-no-background",
                      class: "grid-navigation grid-navigation__next",
                      "aria-label": $options.t('spreed', 'Next page of videos'),
                      onClick: $options.handleClickNext
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconChevronRight, {
                          class: "bidirectional-icon",
                          "fill-color": "#ffffff",
                          size: 20
                        })
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ], 2),
              ($props.isStripe && !$props.isRecording)
                ? (_openBlock(), _createBlock(_component_LocalVideo, {
                    key: 0,
                    ref: "localVideo",
                    class: _normalizeClass(["video", { 'local-video--highlighted': $options.isLessThanTwoVideos && $props.isStripe }]),
                    "is-stripe": true,
                    "show-controls": false,
                    token: $props.token,
                    "local-media-model": $props.localMediaModel,
                    "local-call-participant-model": $props.localCallParticipantModel,
                    onClickVideo: $options.handleClickLocalVideo
                  }, null, 8, ["class", "token", "local-media-model", "local-call-participant-model", "onClickVideo"]))
                : _createCommentVNode("", true),
              ($setup.devMode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_NcButton, {
                      variant: "tertiary",
                      class: "dev-mode__toggle",
                      "aria-label": "Toggle screenshot mode",
                      onClick: _cache[3] || (_cache[3] = $event => ($setup.screenshotMode = !$setup.screenshotMode))
                    }, {
                      icon: _withCtx(() => [
                        (!$setup.screenshotMode)
                          ? (_openBlock(), _createBlock(_component_IconChevronLeft, {
                              key: 0,
                              class: "bidirectional-icon",
                              "fill-color": "#00FF41",
                              size: 20
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (!$setup.screenshotMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", null, "GRID INFO", -1)),
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = (...args) => ($options.disableDevMode && $options.disableDevMode(...args)))
                          }, " Disable "),
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Debug info", -1)),
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = (...args) => ($options.gridDebugInformation && $options.gridDebugInformation(...args)))
                          }, " Log "),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Videos (total):", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.videosCount), 1),
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Displayed videos:", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.displayedVideos.length), 1),
                          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Max per page:", -1)),
                          _createElementVNode("span", null, "~" + _toDisplayString($setup.videosCap), 1),
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Grid width:", -1)),
                          _createElementVNode("span", null, _toDisplayString($data.gridWidth) + "px", 1),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Grid height:", -1)),
                          _createElementVNode("span", null, _toDisplayString($data.gridHeight) + "px", 1),
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Min video width:", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.minWidth) + "px", 1),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Min video Height:", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.minHeight) + "px", 1),
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Grid aspect ratio:", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.gridAspectRatio), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("span", null, "Number of pages:", -1)),
                          _createElementVNode("span", null, _toDisplayString($options.numberOfPages), 1),
                          _cache[20] || (_cache[20] = _createElementVNode("span", null, "Current page:", -1)),
                          _createElementVNode("span", null, _toDisplayString($data.currentPage), 1),
                          _cache[21] || (_cache[21] = _createElementVNode("span", null, "Dummies:", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.dummies) = $event)),
                            type: "number"
                          }, null, 512), [
                            [
                              _vModelText,
                              $setup.dummies,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _cache[22] || (_cache[22] = _createElementVNode("span", null, "Stripe mode:", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($options.devStripe) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, $options.devStripe]
                          ]),
                          _cache[23] || (_cache[23] = _createElementVNode("span", null, "Screenshot mode:", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.screenshotMode) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, $setup.screenshotMode]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"])
  ], 2))
}